export default __webpack_public_path__ + "static/FTRegolaNeue-Heavy-5bee5bc36bed22eb8c8862919467a669.woff";